import { render, staticRenderFns } from "./AdminCampaignGroupingsComponent.vue?vue&type=template&id=ac3a4608"
import script from "./AdminCampaignGroupingsComponent.vue?vue&type=script&lang=js"
export * from "./AdminCampaignGroupingsComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminCampaignGroupingsComponent.vue?vue&type=style&index=0&id=ac3a4608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports